import { ISubAccountData } from "@/store/SubAccountStore";
import { TransferTip } from "@/pages/child-customer/view/child-manage/atom";
import { TextButton } from "@/pages/child-customer/atom";
import { Fragment, useEffect, useState } from "react";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Modal } from "@/components/renderbus-modal";
import { Form, Input } from "@renderbus/ui";
import useForm from "antd/es/form/hooks/useForm";
import { useGlobalStore } from "@/store/GlobalStore";
import request from "project-config/services/request/request";
import { createGlobalStyle } from "styled-components";
import { message } from "antd";
import { useSubAccountStore } from "@/store/SubAccountStore";
import { isEn } from "project-config/utils/env";

export interface ICredit {
  credit: string;
}
export interface ICreditInfo {
  maxCredit: number;
  minCredit: number;
}

export function CreditButton({ onClick }: { onClick: () => void }) {
  const t = getTranslateNsT("center");
  return (
    <Fragment>
      <TextButton type="text" onClick={onClick}>
        {t("user_com_childManage_del_render_btn_setCredit")}
      </TextButton>
    </Fragment>
  );
}

export function CreditModal({
  open,
  setOpen,
  isDingTalkSubAccount,
  ...row
}: ISubAccountData & {
  open: boolean;
  setOpen: (open: boolean) => void;
  isDingTalkSubAccount?: boolean;
}) {
  const t = getTranslateNsT("center");
  const [creditInfo, setCreditInfo] = useState<ICreditInfo>();
  const [form] = useForm<ICredit>();
  const { currencySymbol, fetchUserData } = useGlobalStore();
  const { fetchSubAccountList, fetchDingTalkSubAccountList, isSearchSubUser } =
    useSubAccountStore();
  const creditValidator = (rule: any, value: number, callback: any) => {
    const _value = String(value);
    if (!value) {
      callback(new Error(t("user_com_shiftto_label_fund_empty")));
    }
    if (!/^[0-9.]*$/.test(_value)) {
      form.setFieldValue("credit", "");
      return;
    }
    if (
      creditInfo &&
      (value < creditInfo?.minCredit || value > creditInfo?.maxCredit)
    ) {
      callback(new Error(t("user_com_shiftto_label_fund_error")));
      return;
    }
    if (_value.includes(".") || value % 1 !== 0) {
      if (_value.length > 1 && _value.includes(".")) {
        form.setFieldValue("credit", Math.floor(value));
      } else if (_value.length === 1 && _value.includes(".")) {
        form.setFieldValue("credit", "");
      }
    }
    callback();
  };
  const onOpen = async () => {
    const { data } = await request.post(
      "/api/rendering/user/getAllowableCredit",
      { userId: row.id }
    );
    setCreditInfo(data);
  };
  function handleSubmit() {
    if (row.useMainBalance && form.getFieldValue("credit") > 0) {
      message.warning(t("user_com_private_label_set_balance_error"));
      setOpen(false);
      return;
    }
    form
      .validateFields()
      .then(async () => {
        const res = await request.post("/api/rendering/user/updateCredit", {
          userId: row.id,
          credit: form.getFieldValue("credit"),
        });
        if (res.code === 200) {
          message.success(t("user_com_setCredit_amount_success"));
          fetchUserData();
          if (isDingTalkSubAccount) {
            fetchDingTalkSubAccountList({
              deptId: row.deptId,
              subUserId: isSearchSubUser ? row.id : undefined,
            });
          } else {
            fetchSubAccountList();
          }
        } else {
          message.error(t("user_com_setCredit_amount_fail"));
        }
        setOpen(false);
        form.resetFields();
      })
      .catch(console.trace);
  }
  useEffect(() => {
    if (!open) return;
    onOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <>
      <Modal
        open={open}
        className="renderbus-ui--modal credit"
        title={t("user_com_childManage_del_render_btn_setCredit")}
        destroyOnClose={true}
        children={
          <Fragment>
            <TransferTip>
              {t("user_com_set_credit_pre")}
              <span>{row.subUserName}</span>
              {t("user_com_set_credit_sub")}
            </TransferTip>
            <Form
              size={"large"}
              colon={false}
              requiredMark={false}
              form={form}
              labelCol={{ span: isEn() ? 7 : 6 }}
              labelAlign="right"
            >
              <Form.Item label={t("user_com_setCredit_label_enable_fund")}>
                {`${currencySymbol}${creditInfo?.maxCredit}`}
              </Form.Item>
              <Form.Item
                name="credit"
                label={t("user_com_childManage_del_render_btn_setCredit")}
                rules={[
                  {
                    validator: creditValidator,
                  },
                ]}
              >
                <Input
                  className="credit-input"
                  placeholder={t("user_com_credit_please")}
                />
              </Form.Item>
            </Form>
          </Fragment>
        }
        onCancel={() => {
          setOpen(false);
          form.resetFields();
        }}
        onOk={handleSubmit}
      />
      <CreditStyle />
    </>
  );
}

const CreditStyle = createGlobalStyle`
  .credit-input {
    background: #2C2C31 !important;
    width: 200px;
  }
  .credit .ant-modal-body {
    padding: 24px 24px 22px !important;
    .ant-form-item-row {
      margin-left: ${isEn() ? "-20px" : "-54px"};
    }
  }
`;
